Avatar.theme = Avatar.theme || {};

function RCVariantChange() {
  function updatePriceAfterRCVariantChange() {
    function updatePriceInfo() {
      setTimeout(function () {
        let price = $('#rc_price_onetime').text();

        $('.current_price .money, #rc_price_autodeliver').html(
          '<span>' + price + '</span>' + $('.product-prices .product-price').text()
        );
      }, 5000);

      setTimeout(function () {
        let text = $('.rc_label__autodeliver').html();

        if ($('.rc_label__autodeliver').find('.save').length === 0) {
          text = text
            .replace('save 5%', '<span class="save">save 5%</span>')
            .replace('save 10%', '<span class="save">save 10%</span>')
            .replace('save 15%', '<span class="save">save 15%</span>');
        }

        $('.rc_label__autodeliver').html(text);
      }, 6000);
    }
    updatePriceInfo();

    $(document).on('click', '.rc_label__autodeliver', function () {
      updatePriceInfo();
    });
  }

  return {
    updatePriceAfterRCVariantChange: updatePriceAfterRCVariantChange,
  };
}
// Avatar.theme.RCVariantChange = new RCVariantChange();

jQuery(document).ready(function ($) {
  // Avatar.theme.RCVariantChange.updatePriceAfterRCVariantChange();
});

function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

const moveRCHowItWorks = async () => {
  waitForElm('.rc-widget').then((elm) => {
    const howItWorks = document.querySelector('.how-it-works').innerHTML;
    const sellingPlans = document.querySelector('.subscription-radio');
    const newContainer = document.createElement('div');
    newContainer.innerHTML = howItWorks;
    newContainer.classList.add('subscription-details');
    sellingPlans.insertAdjacentElement('beforeend', newContainer);
  });
};

document.addEventListener('DOMContentLoaded', moveRCHowItWorks);
